import { render, staticRenderFns } from "./ContainerDashboard.vue?vue&type=template&id=628c2e28&scoped=true"
import script from "./ContainerDashboard.vue?vue&type=script&lang=js"
export * from "./ContainerDashboard.vue?vue&type=script&lang=js"
import style0 from "./ContainerDashboard.vue?vue&type=style&index=0&id=628c2e28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628c2e28",
  null
  
)

export default component.exports